import React from "react";

import { Box, Button, Popover, Stack } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { useDateFormatSelect } from "store";

export type AmortizationDateRangeFilterPopoverProps = {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  appliedFrom: string | null;
  appliedTo: string | null;
  onApply: (from: string | null, to: string | null) => void;
  onClear: () => void;
};

export const AmortizationDateRangeFilterPopover: React.FC<AmortizationDateRangeFilterPopoverProps> = ({
  anchorEl,
  onClose,
  appliedFrom,
  appliedTo,
  onApply,
  onClear
}) => {
  const dateFormat = useDateFormatSelect();
  const [draftFrom, setDraftFrom] = React.useState<Dayjs | null>(null);
  const [draftTo, setDraftTo] = React.useState<Dayjs | null>(null);

  React.useEffect(() => {
    if (anchorEl) {
      setDraftFrom(appliedFrom ? dayjs(appliedFrom) : null);
      setDraftTo(appliedTo ? dayjs(appliedTo) : null);
    }
  }, [anchorEl, appliedFrom, appliedTo]);

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      slotProps={{
        paper: { sx: { p: 3, width: 320 } }
      }}
    >
      <Stack spacing={2}>
        <DesktopDatePicker
          label="From"
          format={dateFormat}
          views={["year", "month", "day"]}
          value={draftFrom}
          onChange={(newValue) => setDraftFrom(newValue)}
          sx={{ width: "100%" }}
        />
        <DesktopDatePicker
          label="To"
          format={dateFormat}
          views={["year", "month", "day"]}
          value={draftTo}
          onChange={(newValue) => setDraftTo(newValue)}
          sx={{ width: "100%" }}
        />
        <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
          <Button
            variant="text"
            onClick={() => {
              setDraftFrom(null);
              setDraftTo(null);
              onClear();
              onClose();
            }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              onApply(draftFrom ? draftFrom.format("YYYY-MM-DD") : null, draftTo ? draftTo.format("YYYY-MM-DD") : null);
              onClose();
            }}
          >
            Apply
          </Button>
        </Box>
      </Stack>
    </Popover>
  );
};
